import React, { lazy } from 'react';
import { Route } from 'react-router';

const NewsItemsOverview = lazy(() =>
  import('@pages/Portal/News/NewsItemsOverview').then((m) => ({
    default: m.NewsItemsOverview,
  }))
);

const NewsItemPage = lazy(() =>
  import('@pages/Portal/News/NewsItemPage').then((m) => ({
    default: m.NewsItemPage,
  }))
);

export const portalNewsRoutes = (
  <Route path="news">
    <Route index element={<NewsItemsOverview />} />
    <Route path=":slug" element={<NewsItemPage />} />
  </Route>
);
